"use client"

import { useCodeValues } from "@/hooks/use-code-values"
import type { ValueMapping } from "@/types/fbo-api"
import { CodeTableValueType } from "@/types/fbo-api"

export function useDestinationValueFormatter() {
  const { isReady, getCodeValueText, getCodeValueTextByCode } = useCodeValues()

  const formatDestinationValue = (
    value: ValueMapping["destinationValue"], 
    codeTableName?: string | null,
    codeTableValueType: number = CodeTableValueType.Id
  ): string => {
    if (value === null) {
      return "(null)"
    }
    
    if (value === undefined) {
      return "(undefined)"
    }
    
    if (isReady && codeTableName) {
      if (codeTableValueType === CodeTableValueType.Code && typeof value === "string") {
        const text = getCodeValueTextByCode(value, codeTableName)
        return text ? `${text}: ${value}` : JSON.stringify(value)
      } else if (codeTableValueType === CodeTableValueType.Id && typeof value === "number") {
        const text = getCodeValueText(value, codeTableName)
        return text ? `${text}: ${value}` : JSON.stringify(value)
      }
    }
    
    return JSON.stringify(value)
  }

  return { formatDestinationValue }
}
